import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const staffUserService = {
    getAllStaffUsers: getAllStaffUsers,
    getStaffUserRoles: getStaffUserRoles
};

async function getAllStaffUsers() {
  const localKey = "allStaffUsers";
  const cached = localStorage.getItem(localKey);
  if (cached) {
    try {
      return JSON.parse(cached); 
    } catch (err) {
      console.warn("Failed to parse cached staff users:", err);
      localStorage.removeItem(localKey); 
    }
  }
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const data = await fetch(
    `${config.oat_api_url}/user/staffs/`,
    requestOptions
  ).then(APIHandler.handleResponse);
  localStorage.setItem(localKey, JSON.stringify(data));

  return data;
}

async function getStaffUserRoles() {
    const requestOptions = {
        method: 'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
    };

    const response = await fetch(`${config.oat_api_url}/user/staff/roles/`, requestOptions);
    return APIHandler.handleResponse(response);
}